<template>
  <div class="Login-page">
    <link
      href="https://fonts.googleapis.com/css?family=Roboto"
      rel="stylesheet"
      type="text/css"
    />

    <TemplateLogin v-if="screenWidth > 1200" :typeMode="getTypeMode">
      <LoginForm
        v-if="getTypeMode === ACTUAL_ROLE.TRAINER"
        :is-portal-enabled="isPortalEnabled"
        :type-mode="ACTUAL_ROLE.TRAINER"
      />

      <template v-if="getTypeMode !== ACTUAL_ROLE.TRAINER" v-slot:partner>
        <LoginForm
          :is-portal-enabled="isPortalEnabled"
          :type-mode="ACTUAL_ROLE.SPONSOR"
        />
      </template>
    </TemplateLogin>

    <TemplateLoginMobile
      v-if="screenWidth <= 1200"
      :typeMode="getTypeMode"
      :is-portal-enabled="isPortalEnabled"
    >
    </TemplateLoginMobile>
  </div>
</template>

<script>
'use strict'

import TemplateLogin from '@/components/template/TemplateLogin'

import LoginForm from '@/components/login/LoginForm'
import TemplateLoginMobile from '@/components/template/TemplateLoginMobile.vue'
import LoginFormMobile from '@/components/login/LoginFormMobile.vue'
import { mapGetters } from 'vuex'
import { ACTUAL_ROLE } from '@/utils/consts'

export default {
  name: 'LoginPage',
  watchQuery: ['page', 'order', 'q'],
  components: {
    LoginFormMobile,
    TemplateLoginMobile,
    TemplateLogin,
    LoginForm
  },
  data() {
    return {
      screenWidth: 0
    }
  },

  methods: {
    onScreenResize() {
      window.addEventListener('resize', () => {
        this.updateScreenWidth()
      })
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth
    }
  },

  computed: {
    ACTUAL_ROLE() {
      return ACTUAL_ROLE
    },
    ...mapGetters({
      getTypeMode: 'auth/getTypeMode'
    }),
    isPortalEnabled() {
      return process.env.VUE_APP_PORTAL === 'true'
    }
  },

  beforeMount() {
    this.updateScreenWidth()
    this.onScreenResize()
  },

  mounted() {
    if (
      this.$route.query.type !== undefined &&
      typeof this.$route.query.type === 'string'
    ) {
      // if user write this route "/login?type=Sponsor"
      if (this.$route.query.type === ACTUAL_ROLE.SPONSOR) {
        this.$store.dispatch('auth/setTypeMode', ACTUAL_ROLE.SPONSOR)
        localStorage.setItem('type', ACTUAL_ROLE.SPONSOR)
      }
      // if user write this route "/login?type=Trainer"
      else if (this.$route.query.type === ACTUAL_ROLE.TRAINER) {
        this.$store.dispatch('auth/setTypeMode', ACTUAL_ROLE.TRAINER)
        localStorage.setItem('type', ACTUAL_ROLE.TRAINER)
      }
    } else {
      localStorage.setItem('type', this.getTypeMode)
    }
  }
}
</script>

<style lang="scss">
.Login-page {
  height: 100%;
}
</style>
